import { action } from 'satcheljs';
import type { MailboxInfo } from 'owa-client-types';
import type {
    default as PopoutData,
    DeeplinkPopoutData,
} from 'owa-popout-v2/lib/store/schema/PopoutData';
import type { OpenBizChatSidePaneParams } from 'owa-bizchat-types';
import type { ClientMessage } from 'owa-mail-store';

export interface POPOUT_READING_PANEActionMessage {
    itemId: string | undefined;
    conversationId: string | undefined;
    internetMessageId: string | undefined;
    mailboxInfo: MailboxInfo | undefined;
    data: DeeplinkPopoutData | PopoutData | undefined;
    freezeDryId: string | undefined;
    isFileActivation: boolean | undefined;
    fileActivationExt: string | undefined;
    isCachedItem: boolean | undefined;
    eventTimestamp: number | undefined;
    popOutRowKey: string | undefined;
    openBizChatParams: OpenBizChatSidePaneParams | undefined;
    clientMessage?: ClientMessage;
}
export const popoutReadingPane: (
    itemId?: string,
    conversationId?: string,
    internetMessageId?: string,
    mailboxInfo?: MailboxInfo,
    data?: DeeplinkPopoutData | PopoutData,
    freezeDryId?: string,
    isFileActivation?: boolean,
    fileActivationExt?: string,
    isCachedItem?: boolean,
    eventTimestamp?: number,
    popOutRowKey?: string,
    openBizChatParams?: OpenBizChatSidePaneParams,
    clientMessage?: ClientMessage
) => POPOUT_READING_PANEActionMessage = action(
    'POPOUT_READING_PANE',
    (
        itemId?: string,
        conversationId?: string,
        internetMessageId?: string,
        mailboxInfo?: MailboxInfo,
        data?: DeeplinkPopoutData | PopoutData,
        freezeDryId?: string,
        isFileActivation?: boolean,
        fileActivationExt?: string,
        isCachedItem?: boolean,
        eventTimestamp?: number,
        popOutRowKey?: string,
        openBizChatParams?: OpenBizChatSidePaneParams,
        clientMessage?: ClientMessage
    ): POPOUT_READING_PANEActionMessage => ({
        itemId,
        conversationId,
        internetMessageId,
        mailboxInfo,
        data,
        freezeDryId,
        isFileActivation,
        fileActivationExt,
        isCachedItem,
        eventTimestamp,
        popOutRowKey,
        openBizChatParams,
        clientMessage,
    })
);

export default popoutReadingPane;
